

export const index = 0;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_layout.svelte.js')).default;
export const imports = ["_app/immutable/nodes/0.BZSis_hL.js","_app/immutable/chunks/disclose-version.DQqMciGL.js","_app/immutable/chunks/runtime.4tlg2WhF.js","_app/immutable/chunks/legacy.BTby3Cl7.js","_app/immutable/chunks/slot.BVlYFKWW.js"];
export const stylesheets = ["_app/immutable/assets/0.C7qxMt5k.css"];
export const fonts = ["_app/immutable/assets/roboto-regular.BHeBnKzs.ttf","_app/immutable/assets/roboto-medium.CFKDKRMh.ttf","_app/immutable/assets/sofia-pro-regular.DcCN7_ks.ttf","_app/immutable/assets/sofia-pro-bold.LtCaxDoQ.ttf","_app/immutable/assets/sofia-pro-black.DVGQlFTu.otf"];
